module.exports = __webpack_public_path__ + "static/4-b03f073c0c33c9485faab10d65202188.svg";